import React from 'react';
import { Box, Typography } from '@mui/material';
import { ViolationPolicySection } from './ruleSections/ViolationPolicySection';
import { TaggingPolicySection } from './ruleSections/TaggingPolicySection';
import { TowPolicySection } from './ruleSections/TowPolicySection';
import { ViolationPreview } from './ruleSections/ViolationPreview';
import { WorkflowOptionsSection } from './ruleSections/WorkflowOptionsSection';

interface RulesSectionProps {
	loading: boolean;
}

const RulesSection: React.FC<RulesSectionProps> = ({ loading }) => (
	<Box display="flex" flexDirection="column" gap={1}>
		<Typography variant="body1" fontWeight={300} color="primary">
			Rules
		</Typography>

		<div data-tour="violation-check-frequency"><ViolationPolicySection loading={loading} /></div>
		<div data-tour="warning-policy"><TaggingPolicySection loading={loading} /></div>
		<div data-tour="tow-policy"><TowPolicySection loading={loading} /></div>
		<ViolationPreview />
		<div data-tour="workflow-options"><WorkflowOptionsSection loading={loading} /></div>
	</Box>
);

export default RulesSection;
